export default {
    devices_main_cast_import_manual: "Importar Geometris desde Cast",
    castImportManual_title: "Importar Geometris desde Cast (Manual)",
    castImportManual_description: "Ingresa hasta 300 ESNs (uno por línea o separados por coma) para importarlos desde CAST.",
    castImportManual_placeholder: "ESN1\nESN2\nESN3...",
    castImportManual_esns_entered: "ESNs ingresados",
    castImportManual_max_exceeded: "Puedes ingresar un máximo de 300 ESNs por importación.",
    castImportManual_import: "Importar",
    castImportManual_cancel: "Cancelar",
    castImportManual_success: "Proceso de importación iniciado. Haz clic para ver la transacción.",
    castImportManual_error: "Ocurrió un error al iniciar la importación. Intenta de nuevo.",
};
